import {isEmpty} from 'lodash/lang';
import {fromJS, Map} from 'immutable';
import {sortBy} from 'lodash/collection';
import * as types from 'constants/action-types';
import AccountSocket from 'websockets/account';

const initialState = fromJS({
  isAuthenticated: false,
  user: {},
  totalReadingDates: 0,
});

const setCurrentUserReducer = (state, action) => {
  const {user} = action;
  if (isEmpty(user)) {
    return initialState;
  }
  let {accountSocket} = state;
  if (!isEmpty(user)) {
    accountSocket = new AccountSocket();
  } else if (accountSocket !== null) {
    accountSocket.disconnect();
    accountSocket = null;
  }
  return state.merge(
    fromJS({
      isAuthenticated: !isEmpty(localStorage.getItem('kluwellJwt')),
      user: isEmpty(action.user)
        ? {}
        : (() => {
            const classrooms = isEmpty(user.classrooms) ? [] : sortBy(user.classrooms, [({isActive}) => !isActive]);
            const activeClassroom = user.activeClassroom || {};
            const activeClassroomArchived = !(
              activeClassroom.id &&
              !isEmpty(classrooms.filter(({id, isActive}) => activeClassroom.id === id && isActive))
            );
            return {
              ...action.user,
              activeClassroom: isEmpty(activeClassroom)
                ? {}
                : {...activeClassroom, isActive: activeClassroomArchived ? false : activeClassroom.isActive},
              schoolReadOnly: !(user.activeSchool || {}).isActive,
              classroomReadOnly: activeClassroomArchived,
              level: (user.activeClassroom || {}).level,
              classrooms,
              schools: isEmpty(user.schools) ? [] : sortBy(user.schools, [({isActive}) => !isActive]),
            };
          })(),
      totalReadingDates: action.user ? action.user.totalReadingDates || 0 : 0,
      accountSocket: accountSocket || null,
    }),
  );
};

const setTotalReadingDatesReducer = (state, action) => state.set('totalReadingDates', action.dates);

export default (state = initialState, action = Map()) => {
  switch (action.type) {
    case types.SET_CURRENT_ACCOUNT:
      return setCurrentUserReducer(state, action);
    case types.SET_TOTAL_READING_DATES:
      return setTotalReadingDatesReducer(state, action);
    default:
      return state;
  }
};
